import { AxiosResponse } from "axios";
import apiService from "../api/apiService";

export const merchantAuthController = {
	registerMerchant: (data: {
		firstName: string;
		lastName: string;
		email: string;
		password: string;
	}, turnstileToken?: string | null): Promise<AxiosResponse<any>> =>
		apiService.post("/auth/merchant/register", data,
			turnstileToken ? { headers: { "X-Turnstile-Token": turnstileToken } } : undefined),

	// --- Forgot-password flow: email -> OTP -> reset (captcha on the email step) ---
	forgotPassword: (data: { email: string }, turnstileToken?: string | null): Promise<AxiosResponse<any>> =>
		apiService.post("/auth/merchant/forgot-password", data,
			turnstileToken ? { headers: { "X-Turnstile-Token": turnstileToken } } : undefined),

	verifyForgotPasswordOtp: (data: { requestId: string; otp: string }): Promise<AxiosResponse<any>> =>
		apiService.post("/auth/merchant/forgot-password/verify-email-otp", data),

	resetPassword: (data: { requestId: string; newPassword: string }): Promise<AxiosResponse<any>> =>
		apiService.patch("/auth/merchant/forgot-password/reset-password", data),

	verifySmsOtp: (data: {
		requestId: string;
		otp: string;
	}): Promise<AxiosResponse<any>> =>
		apiService.post("/auth/merchant/verify-sms-otp", data),

	setContactInfo: (data: {
		firstName: string;
		lastName: string;
		email: string;
		isDraft: boolean;
		designation: string;
		primaryContactNo: string;
	}): Promise<AxiosResponse<any>> =>
		apiService.patch("/auth/merchant/set-contact-info", data),

	setBankDetails: (data: {
		isDraft: boolean;
		bankName: string;
		ifscCode: string;
		accountType: string;
		bankAccountNumber: string;
		accountHolderName: string;
	}): Promise<AxiosResponse<any>> =>
		apiService.patch("/auth/merchant/set-bank-details", data),

	setLogisticsInfo: (data: {
		isDraft: boolean;
		pickupLocationNickName: string;
		shipperName: string;
		phone: string;
		address: string;
		city: string;
		state: string;
		country: string;
		pinCode: number;
		lat: number;
		lng: string;
	}): Promise<AxiosResponse<any>> =>
		apiService.patch("/auth/merchant/set-logistics-info", data),

	setBrandDetails: (formData: FormData): Promise<AxiosResponse<any>> =>
		apiService.patch("/auth/merchant/set-brand-details", formData),

	setBusinessInfo: (formData: FormData): Promise<AxiosResponse<any>> =>
		apiService.patch("/auth/merchant/set-business-info", formData),

	updateFcmToken: (data: { fcmToken: string }): Promise<AxiosResponse<any>> =>
		apiService.patch("/auth/merchant/update-fcm-token", data),

	resendSmsOtp: (data: { mobile: string }): Promise<AxiosResponse<any>> =>
		apiService.post("/auth/merchant/resend-sms-otp", data),

	verifyEmailOtp: (data: {
		requestId: string;
		otp: string;
	}): Promise<AxiosResponse<any>> =>
		apiService.post("/auth/merchant/verify-email-otp", data),

	resendEmailOtp: (data: { email: string }): Promise<AxiosResponse<any>> =>
		apiService.post("/auth/merchant/resend-email-otp", data),

	login: (data: {
		email: string;
		password: string;
	}): Promise<AxiosResponse<any>> =>
		apiService.post("/auth/merchant/login", data),

	reissueJwtToken: (data: {
		refreshToken: string;
	}): Promise<AxiosResponse<any>> =>
		apiService.post("/auth/merchant/reissue-jwt-token", data),

	getBrandList: (): Promise<AxiosResponse<any>> =>
		apiService.get("auth/merchant/my-brands"),

	deleteBrand: (brandName: string): Promise<AxiosResponse<any>> =>
		apiService.delete(`/auth/merchant/delete-brand/${brandName}`),

	getProfileInfo: (): Promise<AxiosResponse<any>> =>
		apiService.get("auth/merchant/info"),
};
